import {StringUDF} from "./UDFs/StringUDF";
import {NumberUDF} from "./UDFs/NumberUDF";

export class ChangeStatusConfiguration {


  FieldReaderType: StringUDF;

  FieldValidation: StringUDF;

  ChangeStatusReportId: NumberUDF;

  ProductStatusThingTypeCode: StringUDF;

  ProductStatusLabelReport: StringUDF;

  get(): any{
    return{
      FieldReaderType: this.FieldReaderType.value,
      FieldValidation: this.FieldValidation.value,
      ChangeStatusReportId: this.ChangeStatusReportId.value,
      ProductStatusThingTypeCode: this.ProductStatusThingTypeCode.value,
      ProductStatusLabelReport: this.ProductStatusLabelReport.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/changeStatus.config.ts